import Notification from 'owa-service/lib/contract/Notification';
import WebExtNotificationTypeType from 'owa-service/lib/contract/WebExtNotificationTypeType';

export interface ExtensibilityNotification extends Notification {
    ExtensionId?: string;
    Persistent?: boolean;
}

export interface NotificationMessageArgs {
    icon: string;
    key: string;
    message: string;
    persistent: boolean;
    type: WebExtNotificationTypeType;
}

export interface NotificationMessageResponse {
    icon: string;
    key: string;
    message: string;
    persistent: boolean;
    type: string;
}

export function createExtensibilityNotification(
    extensionId: string,
    persistent: boolean,
    key: string,
    type: WebExtNotificationTypeType,
    message: string,
    icon: string
): ExtensibilityNotification {
    return {
        ExtensionId: extensionId,
        Persistent: !!persistent || type === WebExtNotificationTypeType.ErrorMessage,
        Key: key,
        Type: type,
        Message: message,
        Icon: icon,
    };
}

export function createNotificationMessageResponse(
    notification: ExtensibilityNotification
): NotificationMessageResponse {
    const response: NotificationMessageResponse = {
        key: notification.Key,
        type: getNotificationOutputType(notification.Type),
        message: notification.Message,
        icon: notification.Icon,
        ...(notification.Persistent && { persistent: true }),
    };

    return response;
}

function getNotificationOutputType(type: WebExtNotificationTypeType): string {
    switch (type) {
        case WebExtNotificationTypeType.InformationalMessage:
            return 'informationalMessage';
        case WebExtNotificationTypeType.ErrorMessage:
            return 'errorMessage';
        case WebExtNotificationTypeType.ProgressIndicator:
            return 'progressIndicator';
    }

    return '';
}

export default ExtensibilityNotification;
